import { render, staticRenderFns } from "./BiTableCardUserGroups.vue?vue&type=template&id=8b3a0930&scoped=true&"
import script from "./BiTableCardUserGroups.vue?vue&type=script&lang=js&"
export * from "./BiTableCardUserGroups.vue?vue&type=script&lang=js&"
import style0 from "./BiTableCardUserGroups.vue?vue&type=style&index=0&id=8b3a0930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3a0930",
  null
  
)

export default component.exports